import { 
	defineQuestions, 
	updateCurrentService,
} from './reducers/quiz/quiz.actions';
import { togglePreloader, showError } from './reducers/main/main.actions';
import { defineClientData, addLead, updateLead } from './reducers/client/client.actions';
import { getPhone } from './reducers/quiz/quiz.actions';
import store from './store';
import { 
	EVENT_GET_LEAD, 
	EVENT_GET_APPOINTMENT, 
	EVENT_GET_CLIENT_INFO, 
	EVENT_GET_CALL_TIME,
	CALC_LINK
} from './constants';
import { emitEvent } from './event-emitter';
import { Dispatch } from 'redux';
import { Service } from './models/service.model';
import { Question } from './models/question.model';
import { Client, ServiceInfo } from './models/client.model';
import { Lead } from './models/lead.model';
import { Result } from './reducers/quiz/interfaces/result.interface';
import { set as setState } from './state-switcher';
import { StateType } from './reducers/history/enums/state-type.enum';
import { applyTest } from './utils/abTester';
import { apiService } from './services/api.service';
import { logService } from './services/log.service';
import { EVENT_LOAD_CONTENT } from './constants';

export const makeAppointment = () => async (dispatch:Dispatch, getState: () => any) => {
	const { date, time } = getState().dateForm || {};
	const { lead } = store.getState().client || {};
	const appointment = `${date} ${time}`;
	var data: Partial<Lead> = { appointment };

  dispatch(togglePreloader(true));
  
  try {
    await apiService.updateLead(lead?._id as string, data);

    dispatch(togglePreloader(false));
    emitEvent(EVENT_GET_APPOINTMENT, { appointment, _id: lead?._id });

  } catch (error) {
    console.error(error);
    dispatch(togglePreloader(false));
  }
};

const addCalcLink = (service:Service, clientId:string, amount:number) => {
	return `${CALC_LINK}/?service=${service}&amount=${amount}&clientId=${clientId}`;
}

export const updateLeadRequest = (lead_id:string, fields: any, callback?:Function) => async (dispatch:Dispatch) => {
  const { passed, currentService, results } = store.getState().quiz;
	const { clientId, queryParams, customLeadParams, lead, calculator, location } = store.getState().client || {};
	const amount = currentService == 'braces' ? store.getState().quiz.calculator?.jaws : store.getState().quiz.calculator?.teeth;
	const calcLink = (passed && clientId && calculator) ? addCalcLink(currentService as Service, clientId, amount) : undefined;

  const data = {
		phone: fields.phone,
		clientId: clientId as string,
		...queryParams,
		...customLeadParams,
		calcLink,
		location,
		service: (passed ? currentService : undefined) as Service,
		quizResults: passed ? formatQuizResults(results) : 'Без прохождения теста',
		form_type: lead?.form_type
	}
	
  dispatch(togglePreloader(true, 'transparent'));
  
  try {
    const updatedLead = await apiService.updateLead(lead_id, data);
    console.log("updatedLead", updatedLead);

    callback && callback(updatedLead._id);
    dispatch(togglePreloader(false, 'transparent'));

  } catch (error) {
    console.error(error);
    dispatch(togglePreloader(false, 'transparent'));
  }
}

export const addLeadRequest = (phone:string, name?: string, additionalAgreement?: boolean, callback?:Function) => async (dispatch:Dispatch) => {
	const { passed, currentService, results } = store.getState().quiz;
	const { initialPageIndex } = store.getState().main;
	const { clientId, queryParams, customLeadParams, lead, calculator, location, serviceList, application, whatsApp, specialOffers } = store.getState().client || {};
  const stack = store.getState().history.stack;
	const amount = currentService == 'braces' ? store.getState().quiz.calculator?.jaws : store.getState().quiz.calculator?.teeth;
	const calcLink = (passed && clientId && calculator) ? addCalcLink(currentService as Service, clientId, amount) : undefined;
  const service = serviceList?.length == 1 ? currentService : (passed ? currentService : undefined);
  const bonuses = specialOffers?.enable ? (specialOffers?.list || []) : [];
  
  let openPage = defineOpenPage(initialPageIndex, customLeadParams?.serviceNum);

	let data: any = {
		phone: phone,
		clientId: clientId as string,
		...queryParams,
		...customLeadParams,
		calcLink,
		location,
		service: service as Service,
		quizResults: passed ? formatQuizResults(results) : 'Без прохождения теста',
		form_type: lead?.form_type,
    stepsNum: stack.length,
    openPage,
    wa_enable: whatsApp?.enable,
    wa_onFirstScreen: whatsApp?.onFirstScreen,
    wa_inDoctorBlock: whatsApp?.inDoctorBlock,
    wa_start_page_text: whatsApp?.start_page_text,
    wa_form_page_text: whatsApp?.form_page_text,
    bonuses: bonuses.map(bonus => bonus.label).join(", ")
	}

  if (name) data = { ...data, name };
  if (application?.additionalAgreement?.name && additionalAgreement != undefined) data[application?.additionalAgreement?.name] = additionalAgreement;
  
  dispatch(togglePreloader(true, 'transparent'));
  
  try {
    const receivedLead = await apiService.addLead(data);
    console.log(receivedLead);
    dispatch(addLead(receivedLead));
    dispatch(getPhone(true));
    emitEvent(EVENT_GET_LEAD, {...receivedLead, quizIsPassed: passed});
  
    dispatch(togglePreloader(false));
    callback && callback(receivedLead._id);

    logService.message('Get lead', receivedLead, 'get-lead');
  } catch (error) {
    console.error(error);
    dispatch(showError(500));
    dispatch(togglePreloader(false, "transparent"));
  }
};

export const getQuestions = (service:Service) => async (dispatch:Dispatch) => {
  dispatch(togglePreloader(true));
  
  try {
    const questions = await apiService.getQuestions(service);

    dispatch(defineQuestions(questions));
    dispatch(togglePreloader(false));
  } catch (error) {
    console.error(error);
    dispatch(togglePreloader(false));
  }
};

export const getQuestionsWithoutAdditional = (service:Service) => async (dispatch:Dispatch) => {
  dispatch(togglePreloader(true));
  
  try {
    const questions = await apiService.getQuestions(service, false);

    dispatch(defineQuestions(questions));
    dispatch(togglePreloader(false));
  } catch (error) {
    console.error(error);
    dispatch(togglePreloader(false));
  }
};

export const getEntireData = (clientId:string) => async (dispatch:Dispatch):Promise<void> => {
	dispatch(togglePreloader(true));
  const { currentService: service } = store.getState().quiz;
  
  try {
    let clientData: Client;
    let questions: Question[] = [];
    let content = {};
    
    if (service !== "selection") {
      const [getClientDataResult, getQuestionsResult, getContentResult] = await Promise.all([
        apiService.getClientData(clientId, service),
        apiService.getQuestions(service, false),
        apiService.getContent(service)
      ]);

      clientData = getClientDataResult;
      questions = getQuestionsResult;
      content = getContentResult;
    } else {
      clientData = await apiService.getClientData(clientId);
    }

    if (String(clientData).toLowerCase() == "not allowed") {
      dispatch(showError(403));
      dispatch(togglePreloader(false));
      return;
    }

    const serviceInfo = clientData[service] || {};
    const clientQuestions = serviceInfo.questions ? modifyQuestions(questions, serviceInfo.questions) : questions;
    const defaultData = clientData.default || {};

    dispatch(defineQuestions(clientQuestions));
    dispatch(defineClientData({ ...content, ...clientData.common, name: clientData.name, ...defaultData, ...serviceInfo, clientId, gotEntireData: true }));

    dispatch(togglePreloader(false));
    emitEvent(EVENT_LOAD_CONTENT);

    emitEvent(EVENT_GET_CLIENT_INFO, { name: clientData.name });

  } catch (error) {
    console.error(error);
    dispatch(showError(520));
    dispatch(togglePreloader(false));
  }
}


export const changeService = (service:Service) => async (dispatch:Dispatch, getState:() => any) => {
	dispatch(togglePreloader(true, 'transparent'));

  const { clientId } = store.getState().client || {};

  if (!clientId) return;
  
  try {
    const [questions = [], clientData, content] = await Promise.all([
      apiService.getQuestions(service, false),
      apiService.getClientData(clientId, service),
      apiService.getContent(service)
    ]);

    const serviceInfo: ServiceInfo = clientData[service] || {};
    const defaultData = clientData.default || {};
    const clientQuestions = serviceInfo.questions ? modifyQuestions(questions, serviceInfo.questions) : questions;

    dispatch(defineQuestions(clientQuestions));
    dispatch(updateCurrentService(service));
    dispatch(defineClientData({ ...content, ...defaultData, ...serviceInfo }));

    setTimeout(() => dispatch(togglePreloader(false)), 300);

  } catch (error) {
    console.error(error);
    dispatch(showError(520));
    dispatch(togglePreloader(false));
  }
}

export const sendCallTime = (time:string, callback?:Function) => async (dispatch:Dispatch) => {
	const { lead } = store.getState().client || {};

  dispatch(togglePreloader(true, 'transparent'));
  
  try {
    await apiService.updateLead(lead?._id as string, { callTime: time });

    dispatch(togglePreloader(false));
    dispatch(updateLead({ callTime: time }));

    emitEvent(EVENT_GET_CALL_TIME, { callTime: time });
    callback && callback();

  } catch (error) {
    console.error(error);
    dispatch(togglePreloader(false));
  }
};

function formatQuizResults(arr: Result[]) {
  var result = arr.map(item => {
    const formatedItem: Partial<Result> = { question: item.question, answer: item.answer };
    return Object.values(formatedItem).join(': ').replace('?', '');
  });
  return result.join(',\r\n');
}

function modifyQuestions(original: Question[], custom: Partial<Question>[]): Array<Question> {
  const transformed: Array<Question | undefined> = original.map(question => {
    const target = custom.find(customQuestion => question.name == customQuestion?.name);
    if (target) {
      if (target.header == null) return undefined;
      return { ...question, ...target };
    }
    return question;
  })
  return transformed.filter(elem => elem != undefined) as Array<Question>;
}

function defineOpenPage(initialPageIndex: number, numOfServices: number = 1) {
  if (initialPageIndex == 0) return "start_page";
    else {
      if (numOfServices > 1) return "selection";
      if (numOfServices == 1) return "1_quesiton";
    }
  
  if (initialPageIndex == 99) return "sign_up";
  
  return "other";
}